
import baseMethods from "../baseMethods";

let message = {};
let base_url_wcy03 = baseMethods.wcy03_api_proxy;

//同步欢迎信息
message.welcomeInfo = (payload) => {
    let myURL = base_url_wcy03 + `/sobeyMallMsg/V1/message/welcome?accountId=${payload.accountId}&username=${payload.account}`
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res.code === "SUCCESS") {
                resolve("SUCCESS");
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

export default message;



// WEBPACK FOOTER //
// ./src/api/message/message.js